import React from "react"
import MUIAvatar from "@mui/material/Avatar"
import { useRecordContext } from "react-admin"
import { UserAccountEnum, UserGroupType } from "Types/UserTypes"
import Chip from '@mui/material/Chip';

type PropType = {
    source: string
    label?: string
}

type TypeInfo = {
    label: string,
    color: "default" | "success" | "warning" | "error" | "primary" | "secondary" | "info" | undefined,
    value: number
}

const TypeList : TypeInfo[] = [
    { label: "Taslak", color: "default", value : 0 },
    { label: "Onaylı", color: "success", value : 1 },
    { label: "Red", color: "error", value : 3 },
    { label: "Onay Bekliyor", color: "warning", value : 2 },
]
    
const UserReleaseTypeField = (props: PropType) => {
    const { source } = props
    const record = useRecordContext(props)
    const data = record[source];
    const targetType = TypeList.find((s: TypeInfo) => s.value === data)
    
    return (
        <>
            <Chip label={targetType?.label} color={targetType?.color}  size="small" />
        </>
    )
}

export default UserReleaseTypeField
